import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <video
              src="/video/24_1747705811.mp4"
              controls
              style={{ width: '100%', height: 'auto', marginTop: '90px' }}
              className="img-responsive"
            >

            </video>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>关于我们</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              {/* <h3>为什么选择我们?</h3> */}
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                        <li key={`${d}-${i}`}>{d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                        <li key={`${d}-${i}`}> {d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
